import { Button } from '@lfg/ui/components';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Stack } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomEditor } from 'src/components/CKEditor';
import { Show } from 'src/components/Show';
import { colors } from 'src/global/styles/colors';
import { ProjectInputs } from 'src/global/types/project.type';

import { AdminInput } from '../AdminTextField';

interface FaqItemProps {
  index: number;
  isDisabled?: boolean;
  isModifying: boolean;
  onDelete: () => void;
  onEdit: () => void;
  onSave: () => void;
}
export function FaqItem({ index, isModifying, isDisabled, onDelete, onEdit, onSave }: FaqItemProps) {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<ProjectInputs>();

  return (
    <Box width={'100%'} marginBottom={4} padding={'16px 24px'} border={`1px solid ${colors.neutral015}`}>
      {isModifying ? (
        <Box>
          <Controller
            name={`faqs.${index}.question`}
            control={control}
            render={({ field }) => (
              <AdminInput
                {...field}
                isError={!!errors?.faqs?.[index]?.question}
                errorMsg={errors?.faqs?.[index]?.question?.message}
                type='text'
                placeholder='Enter question'
                disabled={isDisabled}
              />
            )}
          />
          <Box sx={{ paddingTop: 1 }}>
            <CustomEditor
              isError={!!errors?.faqs?.[index]?.answer}
              errorMsg={errors?.faqs?.[index]?.answer?.message}
              value={watch(`faqs.${index}.answer`) as string}
              onChangeCallback={data => setValue(`faqs.${index}.answer`, data)}
              disabled={isDisabled}
            />
          </Box>
          <Stack flexDirection={'row'} justifyContent={'end'} paddingTop={3}>
            <Button
              bgColor={`${colors.brand300}`}
              onClick={onSave}
              sx={{
                padding: '10px 32px !important',
                fontWeight: '500 !important',
                lineHeight: '20px !important',
                borderRadius: '4px !important',
                height: '48px !important',
              }}>
              Save
            </Button>
          </Stack>
        </Box>
      ) : (
        <Stack direction={'row'} alignItems={'center'} columnGap={2}>
          <MenuIcon
            sx={{
              color: 'white',
            }}
          />
          <Stack direction={'column'} rowGap={2} width={'100%'}>
            <Box color={colors.neutral90} fontSize={'14px'}>
              {watch(`faqs.${index}.question`) || 'Question'}
            </Box>
            <Box
              sx={{
                height: '1px',
                width: '100%',
                border: `1px dashed ${colors.neutral015}`,
              }}
            />
            <Box
              color={'white'}
              fontSize={'14px'}
              dangerouslySetInnerHTML={{
                __html: watch(`faqs.${index}.answer`) || '',
              }}></Box>
            <Show when={!isDisabled}>
              <Stack direction={'row'} justifyContent={'end'} columnGap={1}>
                <BorderColorIcon
                  onClick={onEdit}
                  sx={{
                    color: 'white',
                  }}
                />
                <DeleteIcon
                  onClick={onDelete}
                  sx={{
                    color: colors.red300,
                  }}
                />
              </Stack>
            </Show>
          </Stack>
        </Stack>
      )}
    </Box>
  );
}
